export function lorentzToGauss(options) {
    const { dw, length, gaussianHz = 0, exponentialHz = 0, center = 0 } = options;
    if (center > 1 || center < 0) {
        throw new Error('The center of gaussian shape should be inside of the window function: 0 - 1');
    }
    const C5 = Math.pow(0.6 * Math.PI * gaussianHz * dw, 2);
    const C2 = center * (length - 1);
    const C6 = Math.PI * dw * exponentialHz;
    return (i) => Math.exp(i * C6 - Math.pow(C2 - i, 2) * C5);
}
//# sourceMappingURL=lorentzToGauss.js.map